/*
  atc-notice.js - productmelding bij toevoegen aan het mandje, per SKU.

  Markup en teksten staan in snippets/atc-notice.liquid: een gedeelde schil
  (template#atc-notice-tpl) en per melding een <template data-atc-notice="SKU[,SKU]">
  met de tekst in de taal van de bezoeker. Staat een SKU in geen enkele template, dan
  gebeurt er niets.

  DETECTIE, twee wegen naar dezelfde check(cart):
  1. Het event 'cart:updated' (detail.cart = volledige cart.js). PDP, tegel-quick-add en
     de drawer sturen dat na elke wijziging; kost geen verzoek.
  2. PerformanceObserver op elk /cart/add-verzoek, daarna /cart.js via XHR. Vangt de
     routes die geen event sturen (o.a. de upsell-knop in de drawer). Bewust geen wrapper
     om window.fetch: een app vervangt fetch na ons en slaat die over, zie de uitleg in
     preorder-notice.js (zelfde aanpak, gemeten 2026-09-14).

  check(cart) telt per SKU het aantal in het mandje en vergelijkt met de vorige stand.
  De beginstand komt uit Liquid (window.__ATC_NOTICE__.start), dus het laden van een
  pagina kost geen extra /cart.js. Gestegen = toegevoegd = melding, eenmaal per melding
  per sessie. Sluiten alleen via de knop of Escape.
*/
(function () {
  'use strict';

  var NOTICE = {}; // sku -> <template> met de tekst van die melding
  var tpls = document.querySelectorAll('template[data-atc-notice]');
  for (var t = 0; t < tpls.length; t++) {
    var skus = String(tpls[t].getAttribute('data-atc-notice') || '').split(',');
    for (var s = 0; s < skus.length; s++) {
      var sku = skus[s].replace(/^\s+|\s+$/g, '');
      if (sku) NOTICE[sku] = tpls[t];
    }
  }
  if (!Object.keys(NOTICE).length) return;

  var CFG = window.__ATC_NOTICE__ || {};
  var SEEN_KEY = 'co_atc_notice_seen';
  var SETTLE_MS = 450;     // adds bundelen (product + automatische cadeaus komen vlak na elkaar)
  var OPEN_DELAY_MS = 250; // cart drawer / ATC-modal eerst hun animatie laten afmaken

  // ---------------------------------------------------------------- sessie-geheugen
  // sessionStorage kan gooien (private mode, geblokkeerde opslag) -> altijd try/catch.
  function seen() {
    try {
      var raw = window.sessionStorage.getItem(SEEN_KEY);
      var o = raw ? JSON.parse(raw) : null;
      return (o && typeof o === 'object') ? o : {};
    } catch (e) { return {}; }
  }
  function markSeen(key) {
    try {
      var o = seen();
      o[key] = 1;
      window.sessionStorage.setItem(SEEN_KEY, JSON.stringify(o));
    } catch (e) { /* geen opslag: dan toont hij vaker, nooit minder */ }
  }

  // ---------------------------------------------------------------- pop-up bedienen
  var root, slot, okBtn, lastFocus, openTimer;

  function grab() {
    if (root && document.body.contains(root)) return true;
    var shell = document.getElementById('atc-notice-tpl');
    if (!shell || !shell.content) return false;
    document.body.appendChild(shell.content.cloneNode(true));
    root = document.getElementById('an-notice');
    if (!root) return false;
    slot = root.querySelector('[data-an-slot]');
    okBtn = root.querySelector('[data-an-ok]');
    okBtn.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && root.classList.contains('is-open')) close();
    });
    return true;
  }

  function itemImage(it) {
    var src = '';
    if (it && it.featured_image && it.featured_image.url) src = it.featured_image.url;
    else if (it && typeof it.image === 'string') src = it.image;
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  function open(tpl, item) {
    if (!grab()) return;
    slot.innerHTML = '';
    slot.appendChild(tpl.content.cloneNode(true));

    var img = slot.querySelector('[data-an-img]');
    var src = itemImage(item);
    if (img) {
      if (src) {
        img.src = src;
        img.alt = (item && (item.product_title || item.title)) || '';
        img.hidden = false;
        if (img.parentNode) img.parentNode.classList.add('has-img');
      } else {
        img.hidden = true;
      }
    }
    okBtn.textContent = tpl.getAttribute('data-button') || 'OK';

    try { lastFocus = document.activeElement; } catch (e) { lastFocus = null; }
    root.hidden = false;
    void root.offsetWidth; // reflow forceren zodat de open-transitie echt speelt
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    try { okBtn.focus({ preventScroll: true }); } catch (e) { try { okBtn.focus(); } catch (e2) {} }
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      if (root && !root.classList.contains('is-open')) root.hidden = true;
    }, 260);
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    lastFocus = null;
  }

  function show(sku, item) {
    var tpl = NOTICE[sku];
    var key = tpl.getAttribute('data-atc-notice'); // een melding = een sleutel, ook bij meerdere SKU's
    if (seen()[key]) return;
    markSeen(key);
    window.clearTimeout(openTimer);
    openTimer = window.setTimeout(function () { open(tpl, item); }, OPEN_DELAY_MS);
  }

  // ---------------------------------------------------------------- mandje vergelijken
  var known = {}; // sku -> aantal zoals wij het laatst zagen
  var start = CFG.start || [];
  for (var i = 0; i < start.length; i++) {
    var p = start[i];
    if (p && NOTICE[p[0]]) known[p[0]] = (known[p[0]] || 0) + (+p[1] || 0);
  }

  function check(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var qty = {}, first = {};
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var sku = String((it && it.sku) || '');
      if (!NOTICE[sku]) continue;
      qty[sku] = (qty[sku] || 0) + (it.quantity || 0);
      if (!first[sku]) first[sku] = it;
    }
    var hit = null;
    for (var k in NOTICE) {
      if (!Object.prototype.hasOwnProperty.call(NOTICE, k)) continue;
      var now = qty[k] || 0;
      if (!hit && now > (known[k] || 0)) hit = k;
      known[k] = now;
    }
    if (hit) show(hit, first[hit]);
  }

  // ---------------------------------------------------------------- weg 1: cart:updated
  document.addEventListener('cart:updated', function (e) {
    try { check(e && e.detail && e.detail.cart); } catch (err) {}
  });

  // ---------------------------------------------------------------- weg 2: /cart/add zien
  function readCart() {
    // Bewust XHR: als een app-script window.fetch heeft gekaapt, blijft dit werken.
    return new Promise(function (resolve) {
      try {
        var x = new XMLHttpRequest();
        x.open('GET', '/cart.js?_an=' + Date.now(), true);
        x.setRequestHeader('Accept', 'application/json');
        x.onload = function () {
          try { resolve(JSON.parse(x.responseText)); } catch (e) { resolve(null); }
        };
        x.onerror = function () { resolve(null); };
        x.send();
      } catch (e) { resolve(null); }
    });
  }

  var settleTimer;
  function noteAdd() {
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(function () { readCart().then(check); }, SETTLE_MS);
  }

  if (typeof window.PerformanceObserver === 'function') {
    try {
      new PerformanceObserver(function (list) {
        var e = list.getEntries();
        for (var i = 0; i < e.length; i++) {
          if (/\/cart\/add(\.js)?(\?|$)/.test(String(e[i].name || ''))) { noteAdd(); return; }
        }
      }).observe({ type: 'resource', buffered: true });
    } catch (e) { /* oudere browser: weg 1 blijft werken */ }
  }

  // ---------------------------------------------------------------- handmatige haak
  // window.showAtcNotice('<sku>') -> melding tonen, ook al is hij deze sessie al getoond.
  window.showAtcNotice = function (sku) {
    var tpl = NOTICE[String(sku)];
    if (!tpl) return false;
    open(tpl, null);
    return true;
  };
})();
